import type { TierIIStateReporting } from '../../tri-shared/types/tierii-state-fields.ts';

export function chemicalCarrierLabel(carrier: { name: string }, index: number): string {
  const name = carrier.name.trim();
  return `Carrier ${index + 1}` + (name ? ` (${name})` : '');
}

export function isChemicalCarrierField(field: { field: string; label: string }): boolean {
  return field.field === 'text08' && field.label === 'Carrier';
}
export function chemicalCarriersSelected(reporting: TierIIStateReporting, state: string, entryKey: string) {
  return (reporting.chemicalCarriers[state] ?? []).filter((carrier) => carrier.entryKeys.includes(entryKey));
}
export function chemicalCarrierNames(reporting: TierIIStateReporting, state: string, entryKey: string): string | null {
  return (
    chemicalCarriersSelected(reporting, state, entryKey)
      .map((carrier) => carrier.name.trim())
      .filter(Boolean)
      .join('; ') || null
  );
}
export function chemicalCarrierSet(
  reporting: TierIIStateReporting,
  state: string,
  entryKey: string,
  carrierId: string,
  selected: boolean,
): void {
  const carrier = reporting.chemicalCarriers[state]?.find((item) => item.id === carrierId);
  if (!carrier) throw new Error('The selected carrier no longer exists.');
  carrier.entryKeys = selected
    ? [...new Set([...carrier.entryKeys, entryKey])]
    : carrier.entryKeys.filter((key) => key !== entryKey);
}
